import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { Dialog, DialogType } from '@fluentui/react/lib/Dialog';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useClientContext } from '@bingads-webui-campaign-react/smart-page-context';

const getStyles = () => ({
  content: {
    textAlign: 'center',
  },
  actionGroup: {
    textAlign: 'center',
    margin: '20px 30px 0px 30px',
  },
  confirm: {
    borderRadius: 100,
    height: 48,
    padding: '15px 34px 15px 34px',
    fontSize: 18,
    lineHeight: '22px',
    backgroundColor: 'black',
    border: '1px solid black',
    '&:hover': {
      backgroundColor: 'black',
      border: '1px solid black',
    },
  },
});

const dialogStyles = {
  main: {
    maxWidth: 450,
    borderRadius: 5,
  },
};

const dialogContentStyle = {
  title: {
    fontSize: 20,
    padding: 20,
    lineHeight: '24px',
    textAlign: 'center',
  },
};

const mobileDialogContentStyle = {
  title: {
    fontSize: 18,
    padding: 20,
    lineHeight: '20px',
    textAlign: 'center',
  },
};

export const UnstyledPromptDialog = ({
  classes,
  title,
  text,
  i18n,
  hideDialog,
  onCancel,
}) => {
  const { isMobile } = useClientContext();

  const header = (
    <div>
      <span className={classes.title}>{title || i18n.getString(_TL_('Your submission has been sent successfully.'))}</span>
    </div>
  );

  return (
    <Dialog
      hidden={hideDialog}
      onDismiss={onCancel}
      maxWidth="fit-content"
      dialogContentProps={{
        type: DialogType.normal,
        title: header,
        styles: isMobile ? mobileDialogContentStyle : dialogContentStyle,
        showCloseButton: false,
      }}
      modalProps={{
        styles: dialogStyles,
        className: classNames('prompt-dialog', classes.dialog),
      }}
    >

      <div className={classNames('prompt-content', classes.content)}>
        {text || i18n.getString(_TL_('Thanks for reaching out! We\'ll get back to you shortly.'))}
      </div>

      <div className={classes.actionGroup}>
        <PrimaryButton
          className={classNames('prompt-close-button', classes.confirm)}
          onClick={onCancel}
          text={i18n.getString(_TL_('Close'))}
        />
      </div>
    </Dialog>
  );
};

UnstyledPromptDialog.propTypes = {
  classes: PropTypes.shape({
    dialog: PropTypes.string,
    content: PropTypes.string,
    confirm: PropTypes.string,
  }).isRequired,
  title: PropTypes.string,
  text: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  hideDialog: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};

UnstyledPromptDialog.defaultProps = {
  title: '',
  text: '',
};

export const PromptDialog = withDefaultStyles(
  UnstyledPromptDialog,
  getStyles
);
